import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { YouTubePlayerModule } from '@angular/youtube-player';

@Component({
    selector: 'app-youtube-video-player',
    standalone: true,
    imports: [CommonModule, YouTubePlayerModule],
    templateUrl: './youtube-video-player.component.html',
    styleUrl: './youtube-video-player.component.scss',
})
export class YoutubeVideoPlayerComponent implements AfterViewInit {
    public playerVars = {
        autoplay: 1, // Autoplay the video
        controls: 0, // Hide the video controls
        modestbranding: 1, // Limit YouTube branding
        rel: 0, // Do not show related videos at the end
        showinfo: 0, // Do not show video info
        loop: 0, // Loop the video
    };

    @Output() public readonly watched = new EventEmitter<void>();

    @ViewChild('youtubePlayer') public youtubePlayer: ElementRef | undefined;

    public youtubeVideoId: string | undefined;

    /**
     * Can be URL or Video ID
      */
    private videoPath: string | undefined;

    @Input() public get youtubeVideoPath(): string | undefined {
        return this.videoPath;
    }

    public set youtubeVideoPath(value: string | undefined) {
        this.videoPath = value;
        this.youtubeVideoId = this.processYoutubeVideoPath(this.videoPath);
    }

    public ngAfterViewInit(): void {
        this.applyIframeStyles();
    }

    public onPlayerStateChange(event: YT.OnStateChangeEvent): void {
        if (event.data !== YT.PlayerState.ENDED) {
            return;
        }

        this.watched.emit();
    }

    private applyIframeStyles(): void {
        const iframe = this.youtubePlayer?.nativeElement.querySelector('iframe');
        if (iframe) {
            iframe.style.width = '100%';
            iframe.style.height = '100%';
        }
    }

    private extractYouTubeId(url: string): string | undefined {
        // eslint-disable-next-line no-useless-escape
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        const match = url.match(regExp);

        if (match && match[2].length === 11) {
            return match[2];
        } else {
            return undefined;
        }
    }

    private processYoutubeVideoPath(input: string | undefined): string | undefined {
        if (!input) return undefined;
        // Check if input is a YouTube URL
        if (input.includes('youtube.com') || input.includes('youtu.be')) {
            return this.extractYouTubeId(input);
        }

        // If not a URL, return the input as it is assumed to be an ID
        return input;
    }
}
